import { enhanceLinkWithToken } from './enhanceLinkWithToken';
import { replaceBackticksWithCodeTags } from './replaceBackticksWithCodeTags';
import DOMPurify from 'dompurify';

export function renderHtml(html: string, customClasses?: string) {
  if (!html) return null;

  // if there is a magic token, this code will make sure that it's handled correctly
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.hasAttribute('href')) {
      // Enhance the href attribute
      const originalHref = node.getAttribute('href');
      if (originalHref) {
        const enhancedHref = enhanceLinkWithToken(originalHref);
        node.setAttribute('href', enhancedHref);
        node.setAttribute('target', '_blank');
      }
    }
  });

  const sanitizedHtml = DOMPurify.sanitize(replaceBackticksWithCodeTags(html));

  // Remove the hook after sanitization
  DOMPurify.removeHook('afterSanitizeAttributes');

  return (
    <div
      className={`custom-rendering ${customClasses}`}
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml
      }}
    />
  );
}
